(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pills-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const pillsMenuWrapper = document.querySelector('.pills-menu-wrapper');
  pillsMenuWrapper.addEventListener('wheel', (event) => {
    if (event.deltaY !== 0) {
      event.preventDefault();
      pillsMenuWrapper.scrollLeft += event.deltaY;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
